(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["family-style-fest"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        
        const section = document.querySelector("section");

        function handleHash() {
        const hash = window.location.hash;

        // Reset all
        jQuery('.group--heading.group--page-content').removeClass('active');
        jQuery('#shopify-section-template--18262507388970__175734601594cd1522').hide();

        console.log(hash);

        if (hash === '#thank-you') {
          // Show thank-you section
          jQuery('.group--page-content[data-page="thank-you"]').addClass('active').show();
        } else {
          // Default: show the form
          jQuery('.group--heading.group--page-content').addClass('active');
          jQuery('#shopify-section-template--18262507388970__175734601594cd1522').show();
        }
      }

      // Run on page load
      jQuery(document).ready(function() {
        handleHash();
      });

      // Run on hash change
      jQuery(window).on('hashchange', function() {
        handleHash();
      });


        if( localStorage.getItem("goToPage") ){

            window.location.href = localStorage.getItem("goToPage");
            localStorage.removeItem("goToPage");
            
        }

        window.alreadyInThankYouPage = false;
        window.alreadyPhoneFlagReseted = false;

        
        



        let rechargeSubscriptionInterval = setInterval(function(){
            
                
                let hosts = document.querySelectorAll('main .shopify-section form-embed');
                if( hosts ){

                  

                  hosts.forEach( host => {

                      let currentPage = document.querySelector('.group--page-content.active') ? document.querySelector('.group--page-content.active').getAttribute('data-page') : false;

                      if( host.shadowRoot.querySelector('.global-style') ){
                          if( host.shadowRoot.querySelector('.global-style').getAttribute('current-page') != currentPage ){
                              host.shadowRoot.querySelector('.global-style').remove();
                          }
                      }
                      
                      if( !host.shadowRoot.querySelector('.global-style') ){
                      
                      
                              
                              let style = document.createElement( 'style' );
                              style.className = "global-style";
                              style.setAttribute('current-page', currentPage);
                              style.innerHTML = `
                                  [data-current-step="success"]{
                                  opacity: 0;
                                  }
                                  [data-testid="form"]::before{ 
                                  
                                  margin: 12px 0 18px;
                                  font-size: 10px;
                                  line-height: 1.3;
                                  font-weight: 400;
                                  font-family: var(--font-primary);
                                  }
                                  [data-testid="form"] > fieldset > legend{
                                  display: none;
                                  }
                              
                                  [data-testid="form-container"]{
                                  max-width: none !important;
                                  }
                              
                                  [data-testid="form"] > *,
                                  [data-testid="form"] > button[type="submit"],
                                  [data-testid="form"] input[type="text"],
                                  [data-testid="form"] input[type="tel"],
                                  [data-testid="form"] input[type="number"],
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"],
                                  [data-testid="form"] textarea{
                                  box-sizing: border-box;
                                  }
                              
                                  [data-testid="form"] > div{
                                  order: 2;
                                  }
                                  [data-testid="form"] > div label{
                                      top: 17px !important;
                                  font-size: 21px;
                                  font-family: var(--font-link);
                                  color: #50BEDA;
                                  letter-spacing: 0;
                                  text-transform: uppercase;
                                  font-weight: 900;
                                  }
                                  [data-testid="form"] > div input:focus + label,
                                  [data-testid="form"] > div input:not(:placeholder-shown) + label{
                                      transform: scale(0.7) translateY(-14px) !important;
                                  }
                                  
                                  [data-testid="form"]::before{
                                  order: 1;
                                  }
                                  [data-testid="form"] > button[type="submit"]{
                                    order: 4 !important;
                                
                                    display: flex;
                                    height: 50px;
                                    width: 100%;
                                    align-items: center;
                                    border-radius: 50px;
                                    font-size: 21px;
                                    font-family: var(--font-link);
                                    font-weight: 900;
                                    letter-spacing: 0;
                                    background: #FFF203;
                                    color: #000;
                                    line-height: 0;
                                    text-transform: uppercase;
                                  }
                                  [data-testid="form"] > fieldset{
                                    order: 4;
                                  }
                              
                                  [data-testid="form"] input[type="text"],
                                  [data-testid="form"] input[type="tel"],
                                  [data-testid="form"] input[type="number"],
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"],
                                  [data-testid="form"] textarea{
                                  height: 50px;
                                  font-size: 21px;
                                  border-radius: 50px;
                                  background: #F5E8C4;
                                  border: 0;
                                  width: 100%;
                                  }
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"]{
                                          padding-top: 8px !important;
                                      padding-bottom: 8px !important;
                                      padding-left: 18px !important;
                                      
                                  }
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"] span:nth-child(1) img{
                                  display: block;
                                  margin: 0 auto;
                                  height: auto;
                                  width: 40px;
                                  }
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"] span:nth-child(2) svg{
                                  display: none;
                                  }
                                  [data-testid="form"] [aria-controls="country-selector-dropdown"] span:nth-child(2)::before{
                                  content: "";
                                  display: block;
                                  position: relative;
                                  background-image: url(https://cdn.shopify.com/s/files/1/0634/4858/0138/files/Path_37460.svg?v=1741281528);
                                  background-repeat: no-repeat;
                                  width: 21px;
                                  height: 13px;
                                  top: 1px;
                                  right: 2px;
                                  }
                                  [data-testid="form"] textarea{
                                  border-radius: 0;
                                  height: 105px;
                                  }
                                  [data-testid="form"] > fieldset label{
                                  display: block;
                                  }
                                  [data-testid="form"] > fieldset label input{
                                  display: none;
                                  }
                                  [data-testid="form"] > fieldset label span{
                                    position: relative;
                                    display: block;
                                    padding-left: 28px;
                                    font-size: 14px;
                                    cursor: pointer;
                                    line-height: 1.9;
                                    letter-spacing: 0;
                                    padding-top: 2px;
                                  }

                                  @media (max-width: 390px){
                                    [data-testid="form"] > fieldset label span{
                                      font-size: 12px;
                                    }
                                  }
                                  
                                  [data-testid="form"] > fieldset label input + span::before{
                                    content: '';
                                    position: absolute;
                                    left: 0;
                                    top: 3px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    line-height: 0;
                                    width: 20px;
                                    height: 20px;
                                    background: #FFF;
                                    border-radius: 0;
                                    border: 2px solid #312590;
                                    color: #312590;
                                    font-size: 32px;
                                    box-sizing: border-box;
                                    line-height: 1;
                                    padding-bottom: 6px;
                                  }
                                  [data-testid="form"] > fieldset label input:checked + span::before,
                                  [data-testid="form"] > fieldset label span.active::before,
                                  [data-testid="form"] > fieldset label input[type="checkbox"]:checked ~ span::before{
                                    content: '✓';
                                  }
                                  [data-testid="form"] > fieldset:first-of-type{
                                    margin-top: 15px;
                                    
                                  }
                                  [data-testid="form"] > fieldset:last-of-type{
                                    margin-bottom: 20px;
                                  }
                                  [data-testid="form"] > fieldset + fieldset{
                                    margin-top: -6px;
                                  }
                  
                                  [data-sizing="form-wrapper"] > div > section{
                                  display: none;
                                  }
                              `;

                              if( currentPage == 'home' ){
                                  style.innerHTML += `
                                  [data-testid="form"] .form_title{
                                    order: 1;
                                    font-size: 22px;
                                    color: #FFF203;
                                    text-align: center;
                                    line-height: 1.35;
                                    margin: 0;
                                    font-weight: 900;
                                    font-family: var(--font-alt);
                                    text-transform: uppercase;
                                    max-width: 365px;
                                    margin-left: auto;
                                    margin-right: auto;
                                    margin-bottom: 10px;
                                  }
                                  [data-testid="form"] .form_title strong{
                                    color: #000000;
                                  }
                                  /* [data-testid="form"]::after{
                                      order: 1;
                                      content: "We promised it’s a good time";
                                      font-size: 26px;
                                      color: #FFF203;
                                      text-align: center;
                                      line-height: 1.1;
                                      margin: 0;
                                      font-weight: 900;
                                      margin-bottom: 11px;
                                      font-family: var(--font-alt);
                                      text-transform: uppercase;
                                  } */
                                  [data-testid="form"] + div > p{
                                    font-size: 12px;
                                    text-align: left;
                                    margin-top: 40px !important;
                                    line-height: 1.2;
                                  }
                                  `;
                              }

                              if( host.shadowRoot.querySelector('input[type="tel"]') ){
                                  host.shadowRoot.querySelector('input[type="tel"]').setAttribute('pattern', `^[0-9\\-\\+\\s\\(\\)]*$`);
                              }


                              if (!host.shadowRoot.querySelector('h2.form_title')) {
                                const formTitle = document.querySelector('.form_title_content').innerHTML;
                                const formContainer = host.shadowRoot.querySelector('[data-testid="form"]');

                                if (formContainer && formTitle) {
                                  const h2 = document.createElement('h2');
                                  h2.classList.add('form_title');
                                  h2.innerHTML = formTitle; // accept HTML tags from inline_richtext
                                  formContainer.prepend(h2);
                                }
                              }

                              const checkboxes = host.shadowRoot.querySelectorAll('fieldset label input[type="checkbox"]');

                              if (checkboxes) {
                                checkboxes.forEach(checkbox => {
                                  // Check if next sibling is a span
                                  let nextEl = checkbox.nextElementSibling;

                                  if (!nextEl || nextEl.tagName.toLowerCase() !== 'span') {
                                    // Create the span
                                    const span = document.createElement('span');
                                    span.textContent = ''; // or leave empty

                                    // Insert after checkbox
                                    checkbox.parentNode.insertBefore(span, checkbox.nextSibling);
                                  }
                                });
                              }
                                          
                              console.log('global style applied');
                              host.shadowRoot.appendChild( style )

                              console.log( document.querySelectorAll('[data-testid="form"] fieldset label span') );
                      
                      }
              
                      if( host.shadowRoot.querySelector('[data-current-step="success"]') && currentPage == 'home' ){
                          if( !window.alreadyInThankYouPage  ){
                  
                              
                              localStorage.setItem("goToPage", "#thank-you");
                              window.location.reload();
                              window.alreadyInThankYouPage = true;
                  
                              
                          }
                      }

                      


                      
                      let flagButton = host.shadowRoot.querySelector('[aria-controls="country-selector-dropdown"]');
                      if( flagButton ){

                      let flagButtonImage = flagButton.querySelector('span img');

                      // console.log(flagButton, flagButtonImage, flagButtonImage.classList.contains('usa-showed'));

                      let alt_usa = 'United States';
                      let alt_usa_img = 'https://cdn.shopify.com/static/images/flags/us.svg';
                      
                      if( !window.alreadyPhoneFlagReseted ){
                          // flagButtonImage.setAttribute('src', alt_usa_img);
                          // flagButtonImage.setAttribute('alt', alt_usa);
                          // flagButtonImage.classList.add('usa-showed');
                          // window.alreadyPhoneFlagReseted = true;

                          flagButtonImage.click();
                          setTimeout(function(){
                          flagButton.querySelector('#select-country-US').click();
                          }, 50);
                          window.alreadyPhoneFlagReseted = true;
                      }
                      
                      }

                      
                      
                  });
                }
                
                
        }, 20);


        let checkboxClickCooldown = false;

        document.addEventListener('click', function(e) {
          if (checkboxClickCooldown) return; // ignore if still cooling down

          console.log('target:', e.target, 'current:', e.currentTarget);

          if (e.target.matches('[data-testid="form"] > fieldset label span')) {
            e.preventDefault();

            const label = e.target.closest('label');
            const checkbox = label.querySelector('input[type="checkbox"]');

            if (checkbox) {
              checkbox.checked = !checkbox.checked;
              e.target.classList.toggle('active', checkbox.checked);
            }

            // activate cooldown
            checkboxClickCooldown = true;
            setTimeout(() => { checkboxClickCooldown = false; }, 200); // 200ms delay
          }
        });

        
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
